import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

export interface ResultDialogData {
  success: boolean;
  date?: string;
  message?: string;
}

@Component({
  selector: 'app-result-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="result-dialog">
      <div class="icon-container" [class.success]="data.success" [class.error]="!data.success">
        <mat-icon>{{ data.success ? 'check' : 'close' }}</mat-icon>
      </div>

      <h2 class="result-title">{{ data.message || (data.success ? 'Operación exitosa' : 'Error') }}</h2>

      <ng-container *ngIf="data.success; else errorTpl">
        <p class="result-subtitle" *ngIf="data.date; else successNoDate">
          El Tipo de Cambio fue {{ data.message ? (data.message.toLowerCase()) : 'registrado con éxito' }} para la fecha <strong>{{ data.date }}</strong>
        </p>
        <ng-template #successNoDate>
          <p class="result-subtitle">{{ data.message || 'Operación exitosa' }}</p>
        </ng-template>
      </ng-container>

      <ng-template #errorTpl>
        <p class="result-subtitle">{{ data.message || 'No se pudo registrar el Tipo de Cambio. Cierra esta alerta y vuelve a intentarlo' }}</p>
      </ng-template>

      <button *ngIf="data.success" mat-flat-button color="primary" (click)="close()" class="result-button">
        Volver al dashboard
      </button>
      <button *ngIf="!data.success" mat-stroked-button color="warn" (click)="close()" class="result-button">
        Cerrar
      </button>
    </div>
  `,
  styleUrls: ['./result-dialog.component.scss'],
})
export class ResultDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResultDialogData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
